import { render, staticRenderFns } from "./ContractCatalogManage.vue?vue&type=template&id=5b58012d"
import script from "./ContractCatalogManage.vue?vue&type=script&lang=js"
export * from "./ContractCatalogManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports